import { BookedActivitiesTabType } from '../pages/BookedActivitiesPage/types';
import type { IActivitiesEventState } from '../types';

export const initialState: IActivitiesEventState = {
  activityTypeFilterSelection: [],
  currentTab: {
    bookedTabKey: BookedActivitiesTabType.Upcoming,
    landingDateTabKey: undefined,
    otherSessions: {
      dateTabKey: '',
      eventId: undefined,
    },
  },
  appliedFilters: {
    activitiesTypeFilters: [],
    distance: '1.0',
    eventModes: [],
    exerciseIntensities: [],
    recommendedAgeOption: '',
    timeOptions: [],
    startDate: null,
    endDate: null,
    keyword: '',
  },
  filterPageState: {
    activitiesTypeFilters: [],
    distance: '1.0',
    eventModes: [],
    exerciseIntensities: [],
    recommendedAgeOption: '',
    timeOptions: [],
    startDate: null,
    endDate: null,
    keyword: '',
  },
  bookedActivityEvent: undefined,
  bookingError: undefined,
  filterOptions: undefined,
};
